/**
 * Returns the VRChat world page URL for the given world ID.
 */
export function getWorldUrl(worldId: string): string {
  return `https://vrchat.com/home/world/${encodeURIComponent(worldId)}`;
}

/**
 * Returns the VRChat user page URL for the given user ID.
 */
export function getUserUrl(userId: string): string {
  return `https://vrchat.com/home/user/${encodeURIComponent(userId)}`;
}
